documentsToCollect.classy.controller({
    name: 'DocumentsToCollectController',
    inject: ['$scope', '$modal', '$rootScope', 'DateService', 'DocumentsModelService', 'StandardCudFactory',
        'SchoolModelService',  'SchoolTaxModelService', '$rootScope', 'standardCudArrayFactory',
        'authServiceFactory', 'SchoolTaxSchoolService', '$http', 'TaxSettingAffectedFamiliesModelService'],
    init: function() {
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.ModelService = this.ModelService;
        this.$.SchoolModelService = this.SchoolModelService;
        this.$.SchoolTaxModelService = this.SchoolTaxModelService;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.taxinfo = this.SchoolTaxModelService.get()[0];
        this.$.cYear = this.DateService.getCurrentYear(this.$.schoolinfo);
        this.separate(this.SchoolModelService.get()[0].taxDocuments);
        let domain = this.authServiceFactory.getDomain();
        this.$.previewURL = "https://" + domain + "/family_side/faTaxWizDemo.php?schoolID="
            + this.$.authServiceFactory.getAuth().schoolID + "&done=2";
        this.$.previewURL2 = "https://" + domain + "/school_side//si/scSinPreviewTaxLetter.php?schoolID="
            + this.$.authServiceFactory.getAuth().schoolID;
        this.$.versionNo = versionNo;
        this.$rootScope.model = [];
        this.$rootScope.model.push(this.SchoolModelService);
        this.$rootScope.model.push(this.SchoolTaxModelService);
        this.validateVerify(this.$.taxinfo);
        this.runRetroModal();
    },
    runRetroModal: function() {
        if (this.TaxSettingAffectedFamiliesModelService.get().length > 0) {
            this.RetroModal(0);
        }
    },
    separate: function(doc) {
        this.$.documentarray = [];
        let sNumber = doc.toString();

        for (let i = 0, len = sNumber.length; i < len; i += 1) {
            this.$.documentarray.push(parseInt(+sNumber.charAt(i)));
        }

    },
    combine: function(doc, num) {
        if (this.$.schoolinfo.School_Country === "USA") { // to account for business taxes
            if (num === 12 && doc[12] === 0) { // if Business is unchecked, unchecked K1 and 1065
                doc[8] = 0;
                doc[9] = 0;
            } else if (num === 12 && doc[12] === 1) { // if Business is checked, check K1 and 1065
                doc[8] = 1;
                doc[9] = 1;
            } else if (doc[8] === 1 || doc[9] === 1) { // if K1 or 1065 is checked, check Business
                doc[12] = 1;
            } else { // otherwise, uncheck business
                doc[12] = 0;
            }
            this.$.documentarray = doc;
        } else if (this.$.schoolinfo.School_Country === "CAN") { // to account for T1 and it's supporting schedules
            if ((num === 3 && doc[num] === 1) || (num === 4 && doc[num] === 1) || (num === 5 && doc[num] === 1)
                || (num === 6 && doc[num] === 1) || (num === 7 && doc[num] === 1) || (num === 8 && doc[num] === 1)) {
                doc[0] = 1;
            } else if (num === 0 && doc[num] === 0) {
                doc[3] = 0;
                doc[4] = 0;
                doc[5] = 0;
                doc[6] = 0;
                doc[7] = 0;
                doc[8] = 0;
            }
            this.$.documentarray = doc;
        }

        let oldNumber = "";
        for (let key in doc) {
            oldNumber += doc[key].toString();
        }
        this.$.schoolinfo.taxDocuments = oldNumber;
        return this.$.schoolinfo.taxDocuments;
    },
    docPopup: function(index) {
        let parent = this;
        let message = "";
        if (index === 1 && this.$.documentarray[index] === 0) {
            message = "State Tax Forms are used to verify state taxes paid after non-refundable credits are "
                + "deducted (if applicable). Failure to request this document will prevent verification of "
                + " state taxes (where state taxes are applicable).";
        } else if (index === 2 && this.$.documentarray[index] === 0) {
            message = "W-2s are used to verify income stated on Line 7 of 1040. Failure to request this document "
                + "will prevent income verification.";
        } else if (index === 3 && this.$.documentarray[index] === 0) {
            message = "Schedule As are used to verify property tax. Failure to request this document will prevent "
                + "tax verification.";
        }
        if (this.$.documentarray[index] === 0) {
            swal({
                title: "Warning!!",
                text: message,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD68BB",
                cancelButtonText: "Do not proceed",
                confirmButtonText: "Proceed",
                closeOnConfirm: true,
            },
            function(isConfirm) {
                if (isConfirm) {
                    parent.combine(parent.$.documentarray, index);
                } else {
                    parent.$scope.$apply(() => {
                        parent.$.documentarray[index] = 1;
                        parent.combine(parent.$.documentarray, index);
                    });
                }
            });
        } else {
            this.combine(this.$.documentarray, index);
        }
    },
    RetroModal: function(index) {
        if (index === 0) {
            let url = "fast/submodules/schoolside/settings/taxDocuments/documentsToCollect/partials/retroModal.html?v=";
            return this.$modal.open({
                templateUrl: url + versionNo,
                controller: "RetroModalController",
                resolve: {
                    index: function() {
                        return index;
                    }
                }
            });
        }
    },
    DTCModal: function(index) {
        let url = "fast/submodules/schoolside/settings/taxDocuments/documentsToCollect"
                    + "/partials/documentsToCollectModal.html?v=";
        return this.$modal.open({
            templateUrl: url + versionNo,
            controller: "DocumentsToCollectModalController",
            resolve: {
                index: function() {
                    return index;
                }
            }
        });
    },
    submit: function(scope, instance, form) {
        if (form.$valid) {
            instance.options.factor  = .3;
            this.SchoolModelService.put(this.id, this.$.schoolinfo, instance).then(() => {
                this.SchoolModelService.resolveData();
            });

            switch (parseInt(this.$.taxinfo.collectionPreference)) {
                case 1: // ISM Collects and Verifies
                    break;
                case 2: // ISM Collects
                    this.$.taxinfo.currentYearVer = 0;
                    this.$.taxinfo.previousYearVer = 0;
                    this.$.taxinfo.pref = 0;
                    break;
                case 3: // School Collects
                    this.$.taxinfo.currentYearVer = 0;
                    this.$.taxinfo.previousYearVer = 0;
                    this.$.taxinfo.pref = 0;
                    break;
                case 4: // School Collects and ISM Verifies
                    break;
                case 5: // No Collection
                    this.$.taxinfo.currentYearAsk = 0;
                    this.$.taxinfo.currentYearVer = 0;
                    this.$.taxinfo.previousYearAsk = 0;
                    this.$.taxinfo.previousYearVer = 0;
                    this.$.taxinfo.pref = 0;
                    break;
            }

            this.SchoolTaxModelService.put(this.id, this.$.taxinfo, instance).then(() => {
                this.SchoolTaxModelService.resolveData();
            });
        } else {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) {
        this.TaxSettingAffectedFamiliesModelService.resolveData().then(() => {
            this.runRetroModal();
        });
        if (typeof callback !== "undefined") {
            callback();
        }
    },
    activeChange: function(item, field) {
        item[field] = Number(item[field]);
    },
    activeChange2: function(field) {
        this.$.taxinfo[field] = Number(this.$.taxinfo[field]);
    },
    validateVerify: function() {
        if (this.$.taxinfo.currentYearAsk === 1 && this.$.taxinfo.previousYearAsk === 0) {
            this.$.taxinfo.currentYearVer = 1;
            this.$.taxinfo.previousYearVer = 0;
        } else if (this.$.taxinfo.currentYearAsk === 0 && this.$.taxinfo.previousYearAsk === 1) {
            this.$.taxinfo.previousYearVer = 1;
            this.$.taxinfo.currentYearVer = 0;
        } else if (this.$.taxinfo.currentYearAsk === 0 && this.$.taxinfo.previousYearAsk === 0) {
            this.$.taxinfo.currentYearAsk = 1;
            this.$.taxinfo.currentYearVer = 1;
        }
        if (this.$.taxinfo.collectionPreference === 5) {
            this.$.taxinfo.currentYearAsk = 0;
            this.$.taxinfo.currentYearVer = 0;
            this.$.taxinfo.previousYearAsk = 0;
            this.$.taxinfo.previousYearVer = 0;
            if (this.$.schoolinfo.School_Country === "USA") {
                this.$.documentarray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            } else if (this.$.schoolinfo.School_Country === "CAN") {
                this.$.documentarray = [0, 0, 0, 0, 0, 0, 0, 0, 0];
            }
        }
    }

});
